export const isNullOrUndefined = (value: any): boolean => {
    return value === null || value === undefined;
};



// WEBPACK FOOTER //
// ./src/utils/generalUtils.tsx